import * as React from 'react';

interface IInfoProps {
  Icon: React.ReactNode;
  label: string;
  value: string;
}

const Info: React.FunctionComponent<IInfoProps> = ({ Icon, label, value }) => {
  return <div className="bg-gray-50 rounded-lg p-2 border border-gray-100 hover:border-gray-200 transition-colors">
    <div className="flex items-center space-x-2 mb-2">
      {Icon}
      <label className="text-sm font-medium text-gray-700">{label}</label>
    </div>
    <p className="text-sm font-mono text-gray-900 bg-white px-2 py-1 rounded border">
      {value}
    </p>
  </div>;
};

export default Info;
